import axios from 'axios'
import Vue from 'vue'
import router from '../router'
import { gettoken, islogin } from './index'
import { message, notification } from 'ant-design-vue'
import { requestUrl } from './request_url'
// import { reject } from 'core-js/fn/promise'
const request = axios.create({
  baseURL: requestUrl,
  timeout: 60000
})
// let hide = null

const errorHandler = (error) => {
  // hide()
  var originalRequest = error.config;
  if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
    originalRequest._retry = true
    return axios.request(originalRequest);
  }
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    if (error.response.status === 403) {
      Vue.prototype.$notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 500) {
      if (data !== undefined && data.code !== undefined && data.code === -20000) {
        Vue.prototype.$notification.error({
          message: '系统提示',
          description: data.msg
        })
      }
    }
    if (error.response.status === 401) {
      Vue.prototype.$notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
    }
  } else {
    router.push('/NoNet')
  }
  return Promise.reject(error)
}
// 请求拦截处理器
request.interceptors.request.use(function (config) {
  // Do something before request is sent
  const token = gettoken()
  // hide = message.loading('...加载中',0)
  if (token) {
    config.headers['token'] = token

    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  }
  return config;
}, errorHandler);

// 响应拦截处理器
request.interceptors.response.use((response) => {
  // hide()
  if (response.data.code === -10005) {
    if (!window.infoMsg) {
      window.infoMsg && window.infoMsg.destroy();
      window.infoMsg = null;
      window.infoMsg = Vue.prototype.$confirm({
        title: "登录超时",
        content: "登录已经超时，请重新登录",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          router.push('/login')
          window.infoMsg && window.infoMsg.destroy();
          window.infoMsg = null;
        },
        onCancel() {
          window.infoMsg && window.infoMsg.destroy();
          window.infoMsg = null;
        }
      })
    }
    return response.data
  }
  if (response.data.code === 10000 || response.data.code === 10001 || response.data.code === 10002) {
    if (response.data.code === 10000) {
      localStorage.setItem('user_id', response.data.data.userId)
      localStorage.setItem('user_type', response.data.data.userType)
      console.log('user_type:' + response.data.data.userType)
    }
    if (response.headers['token']) {
      localStorage.setItem('ACCESS_TOKEN', response.headers['token'])
    }

    return response.data
  } else if (response.data.code === -20000) {
    Vue.prototype.$notification.error({
      message: '系统提示',
      description: response.data.msg
    })
    return response.data
  }
  return response.data
}, errorHandler);

export default request